import React, { Component } from 'react';
import { MessageCircle, Package } from 'lucide-react';
export function CallToAction() {
  const whatsappNumber = '2348035856111';
  const whatsappMessage = encodeURIComponent("Hello Gauchos Frozen Food, I'm interested in your seafood products.");
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;
  return <section className="bg-gradient-to-br from-teal-600 to-blue-700 py-20" data-id="element-34">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35">
        <div className="text-center mb-12" data-id="element-36">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-37">
            Ready to Stock Up on Quality Seafood?
          </h2>
          <p className="text-teal-50 text-lg max-w-2xl mx-auto" data-id="element-38">
            Whether you need wholesale supply for your restaurant or retail
            purchases for home, we're here to help. Contact us on WhatsApp for
            quick responses.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-39">
          {/* Retail/General Inquiry */}
          <div className="bg-white rounded-2xl p-8 shadow-xl" data-id="element-40">
            <div className="flex items-center justify-center w-14 h-14 bg-teal-100 rounded-full mb-6 mx-auto" data-id="element-41">
              <MessageCircle className="h-7 w-7 text-teal-600" data-id="element-42" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3 text-center" data-id="element-43">
              General Inquiries
            </h3>
            <p className="text-slate-600 mb-6 text-center" data-id="element-44">
              Questions about products, pricing, or availability? Chat with us
              directly.
            </p>
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="block w-full text-center px-6 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors duration-200" data-id="element-45">
              Message on WhatsApp
            </a>
          </div>

          {/* Wholesale Inquiry */}
          <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-teal-400" data-id="element-46">
            <div className="flex items-center justify-center w-14 h-14 bg-blue-100 rounded-full mb-6 mx-auto" data-id="element-47">
              <Package className="h-7 w-7 text-blue-600" data-id="element-48" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3 text-center" data-id="element-49">
              Wholesale Supply
            </h3>
            <p className="text-slate-600 mb-6 text-center" data-id="element-50">
              Looking for bulk orders? Get competitive wholesale pricing for
              your business.
            </p>
            <a href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent("Hello, I'm interested in wholesale pricing and bulk orders.")}`} target="_blank" rel="noopener noreferrer" className="block w-full text-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors duration-200" data-id="element-51">
              Inquire About Wholesale
            </a>
          </div>
        </div>

        <div className="text-center mt-10" data-id="element-52">
          <p className="text-teal-50 text-sm" data-id="element-53">
            Or call us directly:{' '}
            <a href="tel:08035856111" className="font-bold text-white hover:text-teal-200 transition-colors" data-id="element-54">
              0803 585 6111
            </a>
          </p>
        </div>
      </div>
    </section>;
}